var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Huge-icon/user/outline/user"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 255",
    cx: 39.9998,
    cy: 58.3341,
    rx: 23.3333,
    ry: 11.6667,
    stroke: "#9A9FA5",
    strokeWidth: 3,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 257",
    cx: 39.9998,
    cy: 23.3342,
    rx: 13.3333,
    ry: 13.3333,
    stroke: "#9A9FA5",
    strokeWidth: 3,
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.700dcd22acd61f2a4b34ec7b990cb3c4.svg";
export { ForwardRef as ReactComponent };